<template>
  <div>
    <v-app-bar class="header-mobile primary" app>
      <div class="py-2 d-flex align-end">
        <router-link class="d-flex" to="/">
          <img :src="logo" class="header-logo" />
        </router-link>
      </div>

      <v-spacer />

      <v-btn class="white--text" @click="drawer = !drawer" icon>
        <v-icon> fa fa-bars </v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" class="primary" fixed temporary>
      <div class="px-8 py-4 d-flex flex-column">
        <router-link to="/" class="d-flex justify-center">
          <img :src="logo" class="header-logo" />
        </router-link>
      </div>

      <v-divider></v-divider>

      <v-list-item-group v-model="current">
        <v-list>
          <v-list-item v-for="(route, i) in menu" :key="i" :to="route.to" link>
            <v-list-item-content>
              <v-list-item-title
                class="text-body-2 font-weight-bold white--text"
              >
                {{ route.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-list-item-group>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      current: this.$route.path,
      drawer: false,
    };
  },
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    logo() {
      return this.files + this.$rest("informations").item.img;
    },
  },
};
</script>

<style>
.header-mobile {
  z-index: 999 !important;
}

.header-mobile .header-logo {
  height: 42px;
}

.v-navigation-drawer__content .header-logo {
  height: 80px;
}

.v-navigation-drawer {
  z-index: 9999 !important;
}
</style>
